import { FC } from 'react';
import { Progress } from '../../types';
import styles from './ProgressCircle.module.css';

interface ProgressCircleProps extends Progress {
  size?: number;
}

const FULL_DASH_OFFSET = 285;

export const ProgressCircle: FC<ProgressCircleProps> = ({
  size = 54,
  progress = 0,
  total,
}) => {
  const progressPercentage = 1 - progress / total;
  const dashOffset = FULL_DASH_OFFSET * progressPercentage;

  return (
    <svg
      style={{ height: size, width: size }}
      viewBox="0 0 100 100"
      data-testid="progress-circle"
    >
      <circle
        className={styles.circle}
        cx="50"
        cy="50"
        r="45.5"
        strokeDashoffset={dashOffset}
      />
    </svg>
  );
};
